import { styled } from '../../utils/styled'
import Typography from '../Typography'
import Grid from '../Grid'

const getDividerPadding = (hasTextElement: boolean, disablePadding?: boolean): string => {
  if (disablePadding === true) return '0'
  if (hasTextElement) return '4px 0px'
  return '15.5px 0px'
}

export const StyledDividerContainer = styled('div')<{
  $hasTextElement: boolean
  $disablePadding?: boolean
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${({ $hasTextElement: hasTextElement, $disablePadding: disablePadding }) =>
    getDividerPadding(hasTextElement, disablePadding)};
  gap: 8px;
  width: 100%;
`

export const StyledTextContainer = styled(Typography)(({ theme }) => ({
  color: theme.tokens.foreground.main.secondary
}))

export const StyledLine = styled('hr')(({ theme }) => ({
  height: 0,
  borderWidth: '0.5px',
  margin: 0,
  borderStyle: 'solid',
  flexGrow: 1,
  borderColor: theme.tokens.border.main.tonal
}))

export const StyledDividerVerticalContainer = styled(Grid)<{ height?: string | number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: ${({ height }) => (typeof height === 'number' ? `${height}px` : height ?? '100%')};
`

export const StyledVerticalLine = styled('div')(({ theme }) => ({
  width: 0,
  borderWidth: '0.5px',
  margin: 0,
  borderStyle: 'solid',
  flexGrow: 1,
  borderColor: theme.tokens.border.main.tonal
}))
